/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/edit/delete/delete_styles';



/* ========== ~~~~~~~~~~ EMBED : DELETE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Delete extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick() {
        if (this.props.optionId) {
            this.props.removeOption(this.props.contentId, this.props.optionId);
        } else {
            this.props.deleteContent(this.props.contentId);
        }
    }
    render() {
        if ((this.props.optionId) && (this.props.numberOfOptions < 3)) { return null }
        return (
            <div className={`editorelement delete ${this.props.classes.delete} ${this.props.position}`} onClick={this.handleClick} >
                <Icon name={`trash-alt`} />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Delete);
